module.exports = __webpack_public_path__ + "img/marumo-gallants-logo-icon.54fc2f90.png";